__webpack_require__.p = "https://www.uma.pt/wp-content/themes/uma/departamentosapp/";